import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiPost, qk } from "@/shared/api";

/**
 * Остановка робота.
 *
 * `Idempotency-Key` здесь не нужен и контрактом не предусмотрен: операция
 * идемпотентна сама по себе — повторный запрос по уже остановленному роботу
 * возвращает 409 `CONFLICT`, а не останавливает его второй раз.
 *
 * Цена покупки НЕ возвращается на баланс (так решено на бэкенде), поэтому
 * `wallet` в инвалидации нет — двигаются только портфель, главная и лента.
 */
export function useStopRobot(userRobotId: number) {
  const client = useQueryClient();

  return useMutation({
    mutationFn: () =>
      apiPost("/api/v1/my-robots/{user_robot_id}/stop", {
        params: { user_robot_id: userRobotId },
      }),
    onSuccess: () => {
      // Префиксы, а не точные ключи: и главная, и деталь робота
      // параметризованы периодом графика.
      for (const key of [["home"], qk.myRobots(), ["my-robots", "detail", userRobotId]]) {
        void client.invalidateQueries({ queryKey: key });
      }
      void client.invalidateQueries({ queryKey: ["activity"] });
    },
  });
}
